import type {Point} from '@yandex-delivery/core/types'

import type {Props} from '../model'

function arePointsEqual(a: Point, b: Point) {
  return a[0] === b[0] && a[1] === b[1]
}

export function arePropsEqual(prevProps: Props, nextProps: Props) {
  return (
    !!nextProps.polygon &&
    prevProps.polygon?.length === nextProps.polygon.length &&
    prevProps.polygon.every((a, index) => {
      const b = nextProps.polygon?.at(index)
      return b && arePointsEqual(a, b)
    })
  )
}
